import { getItemUid } from 'entities/CatalogItem/lib/getItemUid';
import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import { getCustomListCatalogItem } from 'entities/CustomList';
import { fetchOrder } from 'entities/Order';
import { deleteOrderItem } from 'features/removeItemsInOrder/model/services/deleteOrderItem/deleteOrderItem';

import type { AppDispatch } from 'app/providers/StoreProvider';
import type { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import type { CustomListItem } from 'entities/CustomList';
import type { CatalogIdentity } from 'shared/lib/contexts/CatalogIdentityContext';

interface RemoveCustomListItemsFromOrderOptions {
    dispatch: AppDispatch;
    listItems: CustomListItem[];
    identity: CatalogIdentity;
    selectedItems: Record<string, Partial<MappedCatalogItem>> | undefined;
    orderId?: string;
}

export const removeCustomListItemsFromOrder = async ({
    dispatch,
    listItems,
    identity,
    selectedItems,
    orderId,
}: RemoveCustomListItemsFromOrderOptions): Promise<boolean> => {
    for (const listItem of listItems) {
        const catalogItem = getCustomListCatalogItem(listItem);
        if (!catalogItem) {
            continue;
        }

        const selectionKey = getItemUid(catalogItem, identity);
        const selection = selectedItems?.[selectionKey];
        if ((selection?.qty ?? 0) < 1) {
            continue;
        }

        if (orderId && selection?.orderItemId) {
            const result = await dispatch(
                deleteOrderItem({
                    orderId,
                    itemId: selection.orderItemId,
                }),
            );
            if (result.meta.requestStatus !== 'fulfilled') {
                return false;
            }
        }

        dispatch(catalogItemActions.removeMultiselectItem(selectionKey));
        dispatch(catalogItemActions.removeNewItem(selectionKey));
    }

    if (orderId) {
        await dispatch(fetchOrder({ id: orderId, isCatalog: true }));
    }

    return true;
};
